import { Box, Typography } from "@mui/material";
import React from "react";

function ComingSoon() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="90vh"
    >
      <Typography variant="h3">Coming Soon</Typography>
    </Box>
  );
}

export default ComingSoon;
